import React, { useState } from 'react';
import './FAQSection.css';

const faqs = [
  {
    question: 'Can I bring my own stroller inside?',
    answer: 'Yes, absolutely! We have designated stroller parking areas inside and all aisles are wide enough for easy navigation. We also have stroller covers available during rainy days.',
  },
  {
    question: 'Is there a private nursing area?',
    answer: 'Yes, we have a dedicated nursing room with comfortable armchairs, dimmable lighting, power outlets for pumps, and complimentary water. The room is cleaned every hour.',
  },
  {
    question: 'Do you offer baby food or formula?',
    answer: 'We have a kids menu with organic baby food options. We also stock emergency formula and can warm bottles. Please let staff know about any allergies.',
  },
  {
    question: 'Are pets allowed?',
    answer: 'For the safety of our youngest guests, only service animals are permitted inside the facility. We have water bowls available for service animals.',
  },
  {
    question: 'Do I need a reservation?',
    answer: 'Reservations are not required but recommended during weekends and holidays. You can book a table through our website or by calling us directly.',
  },
  {
    question: 'Is there a play area for toddlers?',
    answer: 'Yes! Our supervised soft play zone is designed for children 6 months to 5 years. The area has padded flooring, age-appropriate toys, and is visible from the dining area.',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="faq-section">
      <h2 className="faq-title">Frequently asked questions</h2>
      <div className="faq-list">
        {faqs.map((faq, idx) => (
          <div key={idx} className={`faq-item ${openIndex === idx ? 'faq-item--open' : ''}`}>
            <button 
              className="faq-question" 
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            >
              <span>{faq.question}</span>
              <span className="faq-toggle">{openIndex === idx ? '−' : '+'}</span>
            </button>
            {openIndex === idx && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
